import { useEffect, useState } from "react";
import { Button, Table } from "reactstrap";
import { toast } from "react-toastify";

import { confirm } from "components/Confirmation";
import IconButton from "components/IconButton";
import componenteService from "services/ComponenteService";
import { StatusComponenteEnum, estadoComponenteText, statusComponenteText } from "services/ComponenteService";
import ModalIncluir from "./ModalIncluir";

export default function Componentes({ pai, onChange, podeGerenciar }) {
  const [items, setItems] = useState([])
  const [modalAberto, setModalAberto] = useState(false)

  const podeMontar = podeGerenciar && pai?.status == StatusComponenteEnum.ESTOQUE

  const carregar = async () => {
    if (!pai?.id) return
    const res = await componenteService.listarFilhos(pai.id)
    if (res.success) {
      setItems(res.data)
    }
  }

  useEffect(() => {
    carregar()
  }, [pai?.id])

  const handleIncluir = async (item) => {
    try {
      await componenteService.vincularFilho(pai.id, item.id)
      toast("Componente vinculado como filho")
      carregar()
      onChange && onChange()
    } catch (ex) {
      if (!!ex.response?.data?.message)
        toast(ex.response.data.message)
      else
        toast("Erro ao vincular o componente")
    }
  }

  const handleRemover = (item) => {
    confirm({
      header: "Remover filho",
      text: `Tem certeza que deseja desvincular o componente ${item.qrCode} deste pai?`,
      icon: "bi-exclamation-triangle",
      onConfirm: async () => {
        try {
          await componenteService.desvincularFilho(item.id)
          toast("Componente desvinculado")
          carregar()
          onChange && onChange()
        } catch (ex) {
          if (!!ex.response?.data?.message)
            toast(ex.response.data.message)
          else
            toast("Erro ao desvincular o componente")
        }
      }
    })
  }

  return (
    <>
      <div className="d-flex flex-row justify-content-end align-items-center pb-4">
        <Button color="primary" onClick={() => setModalAberto(true)} disabled={!podeMontar}>
          Adicionar filho
        </Button>
      </div>

      <Table className="align-items-center table-flush" responsive>
        <thead className="thead-light">
          <tr>
            <th scope="col">QRCode</th>
            <th scope="col">Tipo</th>
            <th scope="col">Modelo</th>
            <th scope="col">Estado</th>
            <th scope="col">Status</th>
            <th scope="col">Localização</th>
            <th scope="col" style={{ width: 60 }}></th>
          </tr>
        </thead>
        <tbody>
          {items.length == 0 && (
            <tr>
              <td colSpan={7} className="text-center">Nenhum registro</td>
            </tr>
          )}
          {items.map(el => (
            <tr key={el.id}>
              <td>{el.qrCode}</td>
              <td>{el.tipoComponente}</td>
              <td>{el.modelo}</td>
              <td>{estadoComponenteText(el.estado)}</td>
              <td>{statusComponenteText(el.status)}</td>
              <td>{el.cruzamento ? `Cruzamento ${el.cruzamento.numero}` : ''}</td>
              <td className="d-flex flex-row gap-5px">
                <IconButton alt="Remover" iconClass="bi-trash" onClick={() => handleRemover(el)} disabled={!podeMontar} />
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      <ModalIncluir
        isOpen={modalAberto}
        idContrato={pai?.idContrato}
        onClose={() => setModalAberto(false)}
        onSelect={handleIncluir}
      />
    </>
  )
}
